import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";  
import { RootState } from "../../store/store";
import { ReactElement, ComponentType } from "react";

interface PrivateRouteProps {
  element: ComponentType<any>; // Component can accept any props
  [key: string]: any; // Accept optional props dynamically
}

function PrivateRoute({ element: Component, ...rest }: PrivateRouteProps): ReactElement {
  const { isLogin } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!isLogin) { 
        sessionStorage.setItem("redirectAfterLogin", location.pathname + location.search);

    return <Navigate to="/" />;
  }

  return <Component {...rest} />; // Pass additional props conditionally
}

export default PrivateRoute;
